<template>
  <div class="border">
    <el-form :inline="true" :model="searchForm" class="demo-form-inline" label-position="right" label-width="10px">
      <el-form-item label=" ">
        <el-input v-model="searchForm.name" width="500px" clearable placeholder="code/名称/描述模糊查询"></el-input>
      </el-form-item>
      <el-form-item>
        <el-button type="primary" icon="el-icon-search" @click="page=1;list();">查询</el-button>
      </el-form-item>
    </el-form>
    <template>
      <el-table ref="variablesTable" :data="tableData" border stripe highlight-current-row @selection-change="handleSelectionChange">
        <el-table-column prop="name" label="code" header-align="center" align="center" />
        <el-table-column prop="desc" label="名称" header-align="center" align="center" />
        <el-table-column prop="defaultValue" label="默认值" header-align="center" align="center" />
        <el-table-column prop="code" label="征信源" header-align="center" align="center"/>
        <el-table-column prop="type" label="类型" header-align="center" align="center"/>
        <el-table-column prop="comment" label="描述" header-align="center" align="center" show-overflow-tooltip/>
        <el-table-column prop="updateTime" label="更新时间" header-align="center" align="center"/>
        <el-table-column prop="createTime" label="创建时间" header-align="center" align="center"/>
      </el-table>
      <el-pagination
        @current-change="handleCurrentChange"
        @size-change="handleSizeChange"
        :current-page="page"
        :page-sizes="[10, 20, 50, 100]"
        :page-size="pageSize"
        layout="->,total, sizes, prev, pager, next, jumper"
        :total="total">
      </el-pagination>
    </template>
  </div>
</template>

<script>
export default {
  props: {
  },
  data () {
    return {
      searchForm: {
        name: ''
      },
      tableData: [],
      strategy: {},
      page: 1,
      pageSize: 10,
      total: 0,
      selectIds: [],
      showAddFlag: false,
      showCopyFlag: false
    }
  },
  created () {
    this.list()
  },
  methods: {
    async list () {
      console.log(process.env)
      let params = {
        ...this.searchForm,
        page: this.page,
        pageSize: this.pageSize
      }
      try {
        const res = await this.$http.post(`${process.env.BIG_DATA_URL}/vtnopenplatform/credit-query`, params)
        if (res.code === 200) {
          this.tableData = res.data.creditQueryModelList
          this.total = res.data.sum
        } else {
          this.$message.error(res.message)
        }
      } catch (err) {
        console.error(err)
      }
    },
    handleCurrentChange (currentPage) {
      this.page = currentPage
      this.list()
    },
    handleSizeChange (size) {
      this.page = 1
      this.pageSize = size
      this.list()
    },
    handleSelectionChange (val) {
      this.selectIds = []
      val.forEach(v => {
        this.selectIds.push(v.id)
      })
    }
  }
}
</script>

<style lang="stylus">
  .el-tooltip__popper {
    max-width: 40%;
    line-height: 180%;
  }
</style>



// WEBPACK FOOTER //
// src/views/variablesCenter/list.vue